import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import { Navigate } from 'react-router-dom'
import WarrantyRegistrationForm from '../components/forms/WarrantyRegistrationForm'
import { useAuth } from '../hooks/context/UserAuthContext'

const WarrantyRegistration = () => {
  const { user } = useAuth()
  if (user) {
    switch (user.dealershipBrand) {
      case 'mercedes':
        return <Navigate to='/mercedes-benz' replace />
      case 'bmw':
        return <Navigate to='/bmw' replace />
      case 'jlr':
        return <Navigate to='/jlr' replace />
      case 'vw':
        return <Navigate to='/vw' replace />
      case 'byd':
        return <Navigate to='/byd' replace />
      case 'vwsg':
        return <Navigate to='/vwsg' replace />
      default:
        break
    }
  }
  return (
    <Container maxWidth='md' sx={{ py: 2 }}>
      <Box
        component='img'
        maxWidth='100%'
        mx='auto'
        mb={2}
        src='/images/banners/banner-mb-2022-08-02.png'
      />
      <Box mb={2}>
        <Typography variant='h5'>Warranty Registration</Typography>
      </Box>
      <WarrantyRegistrationForm />
    </Container>
  )
}

export default WarrantyRegistration
